export const GET_TIPS = "GET_TIPS";
export const GET_STATE_LOADING = "GET_STATE_LOADING";
